import React from 'react';
import RecomendationSkeleton from './recomendation-skeleton';
import SimilarsSkeleton from './similars-skeleton';
import UGCSkeleton from './ugc-get/skeleton';
const PDPSkeleton = () => {
  return <div className='absolute right-0 top-0 z-[1000] h-full w-full overflow-hidden bg-white' data-sentry-component="PDPSkeleton" data-sentry-source-file="skeleton.tsx">
            <div className='pdp-container flex flex-col lg:gap-x-4'>
                <div className='h-6 w-full animate-pulse rounded bg-gray-100 lg:w-56' />

                <div className='flex flex-col gap-8 lg:flex-row'>
                    {/* Gallery */}
                    <div className='relative mt-2 gap-3 lg:mt-6 lg:flex'>
                        <div className='hidden h-full max-h-[316px] space-y-2 overflow-hidden lg:block'>
                            <div className='h-10 w-10 animate-pulse rounded bg-gray-100' />
                            <div className='h-10 w-10 animate-pulse rounded bg-gray-100' />
                            <div className='h-10 w-10 animate-pulse rounded bg-gray-100' />
                            <div className='h-10 w-10 animate-pulse rounded bg-gray-100' />
                            <div className='h-10 w-10 animate-pulse rounded bg-gray-100' />
                            <div className='h-10 w-10 animate-pulse rounded bg-gray-100' />
                            <div className='h-10 w-10 animate-pulse rounded bg-gray-100' />
                        </div>

                        <div className='hidden flex-col gap-3 lg:flex'>
                            <div className='h-[316px] w-[316px] animate-pulse rounded bg-gray-100' />

                            <div className='h-6 w-full animate-pulse rounded bg-gray-100' />
                        </div>

                        <div className='mx-auto aspect-square w-64 animate-pulse rounded bg-gray-100 lg:hidden' />
                    </div>

                    {/* Product detail */}
                    <div className='flex flex-grow flex-col'>
                        <div className='flex lg:hidden'>
                            <div className='ml-4 grow'>
                                <div className='h-6 w-full animate-pulse rounded bg-gray-100' />
                                <div className='mt-1.5 h-6 w-full animate-pulse rounded bg-gray-100' />
                            </div>
                            <div className='mr-auto flex gap-3'>
                                <div className='h-6 w-6 animate-pulse rounded bg-gray-100' />
                                <div className='h-6 w-6 animate-pulse rounded bg-gray-100' />
                            </div>
                        </div>

                        <div className='mt-3 h-5 w-full animate-pulse rounded bg-gray-100 lg:h-6' />

                        <div className='mt-4 h-6 w-full animate-pulse rounded bg-gray-100 lg:h-12' />

                        <div className='relative left-2 mt-3 h-8 w-screen animate-pulse bg-gray-100 lg:left-0 lg:h-6 lg:w-full lg:rounded' />

                        <div className='mt-3 h-18 w-full animate-pulse rounded bg-gray-100 lg:h-6' />

                        <div className='relative left-2 mt-3 h-[82px] w-screen animate-pulse bg-gray-100 lg:left-0 lg:h-6 lg:w-full lg:rounded' />

                        <div className='mt-3 h-[172px] w-full animate-pulse rounded bg-gray-100 lg:h-6' />
                        <div className='mt-4 h-12 w-full animate-pulse rounded bg-gray-100 lg:mt-0 lg:h-[136px]' />
                    </div>

                    {/* Buy box */}
                    <div className='hidden flex-col gap-2 lg:flex'>
                        <div className='mr-auto flex gap-3'>
                            <div className='h-6 w-6 animate-pulse rounded bg-gray-100' />
                            <div className='h-6 w-6 animate-pulse rounded bg-gray-100' />
                        </div>

                        <div className='flex h-[352px] w-[316px] flex-col justify-between rounded border border-border-gray-light bg-surface-solid-0 px-3 py-5'>
                            <div className='h-24 w-full animate-pulse rounded bg-gray-100' />
                            <div className='h-36 w-full animate-pulse rounded bg-gray-100' />
                        </div>

                        <div className='h-14 w-full animate-pulse rounded bg-gray-100' />
                    </div>
                </div>

                <div className='mt-3 hidden h-52 w-full animate-pulse rounded bg-gray-100 lg:block' />
                <div className='mt-6 hidden h-12 w-full animate-pulse rounded bg-gray-100 lg:block' />

                <RecomendationSkeleton data-sentry-element="RecomendationSkeleton" data-sentry-source-file="skeleton.tsx" />
                <SimilarsSkeleton data-sentry-element="SimilarsSkeleton" data-sentry-source-file="skeleton.tsx" />
                <RecomendationSkeleton data-sentry-element="RecomendationSkeleton" data-sentry-source-file="skeleton.tsx" />

                <div className='flex gap-8'>
                    <UGCSkeleton data-sentry-element="UGCSkeleton" data-sentry-source-file="skeleton.tsx" />

                    <div className='mt-8 hidden flex-col gap-2 lg:flex'>
                        <div className='flex h-[352px] w-[316px] flex-col justify-between rounded border border-border-gray-light bg-surface-solid-0 px-3 py-5'>
                            <div className='h-6 w-full animate-pulse rounded bg-gray-100' />
                            <div className='h-24 w-24 animate-pulse rounded bg-gray-100' />
                            <div className='h-36 w-full animate-pulse rounded bg-gray-100' />
                        </div>

                        <div className='h-14 w-full animate-pulse rounded bg-gray-100' />
                    </div>
                </div>
            </div>
        </div>;
};
export default PDPSkeleton;